import { render, staticRenderFns } from "./CollectionInstanceUnitUserEdit.vue?vue&type=template&id=1899242a"
import script from "./CollectionInstanceUnitUserEdit.vue?vue&type=script&lang=js"
export * from "./CollectionInstanceUnitUserEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports